function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Button from 'react-bootstrap/Button';
import React from "react";
import { deepMap, hydrate } from '../DataStructures';
import { useEffect, useState, useRef } from 'react';
const UpdatingPopover = /*#__PURE__*/React.forwardRef(({
  popper,
  children,
  show: _,
  ...props
}, ref) => {
  useEffect(() => {
    popper.scheduleUpdate();
  }, [children, popper]);
  return /*#__PURE__*/React.createElement(Popover, _extends({
    style: {
      padding: "10px"
    },
    ref: ref
  }, props), children);
});
const afterCopy = `Copied!`;
const beforeCopy = 'Copy Component';
const CopyComponentButton = ({
  selectedChildren,
  selectedChild,
  setCopiedComponent,
  onChanged
}) => {
  const [content, setContent] = useState(beforeCopy);
  const handleButtonMouseLeave = event => {
    setContent(beforeCopy);
  };
  return /*#__PURE__*/React.createElement(OverlayTrigger, {
    trigger: ['hover', 'focus'],
    placement: "right",
    overlay: /*#__PURE__*/React.createElement(UpdatingPopover, null, content)
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    className: "mr-2 mt-2",
    disabled: selectedChildren.length === 0,
    onMouseLeave: handleButtonMouseLeave,
    onBlur: handleButtonMouseLeave,
    onClick: () => {
      let cloned = JSON.stringify(selectedChild);
      setCopiedComponent(cloned);
      setContent(afterCopy);
      onChanged();
    }
  }, /*#__PURE__*/React.createElement("i", {
    className: "bi bi-intersect"
  })));
};
export default CopyComponentButton;